import * as yup from 'yup';
import type { FormDefinition } from '@gov-design-system-ce/react-form-core';
import {
	getFormDefinition,
	useGovForm,
} from '@gov-design-system-ce/react-form-core';
import type { DatovkaApiType } from '@gov-nx/api';
import { useAuthorizationConsentYupSchema } from '@gov-nx/core/hooks';
import { dataBoxParams, useDataBoxShape } from '@gov-nx/utils/common';
import type { DataRequest, FormData } from './service.types';

export interface FormInstanceProps {
	dataBoxTypes: DatovkaApiType['typSchranky'][];
	isLowAuthorization: boolean;
}

export function FormInstance({
	dataBoxTypes,
	isLowAuthorization,
}: FormInstanceProps): FormDefinition<FormData> {
	const { getDataBoxShape, getDataBoxDefaultValues } = useDataBoxShape({
		types: dataBoxTypes,
	});
	const consentSchema = useAuthorizationConsentYupSchema({
		isConsentRequired: isLowAuthorization,
	});

	const formSchema = yup
		.object({
			...getDataBoxShape({ isRequired: true }),
		})
		.shape({ __souhlas: consentSchema })
		.required();

	const formMethods = useGovForm<FormData>({
		formSchema,
		defaultValues: getDataBoxDefaultValues(),
	});

	return getFormDefinition({ formMethods, formSchema });
}

export function prepareSubmitData(licenceNumber?: string) {
	return (formData: FormData): DataRequest => ({
		params: dataBoxParams(formData),
		body: {
			typVypisu: 'BODOVE_HODNOCENI_RIDICE',
			data: {
				cisloRP: licenceNumber,
			},
		},
	});
}
